export default __webpack_public_path__ + "static/media/Humboldtpinguin.e5380fb6.jpg";